const Text = {
  headers: {
    aboutMe: "About Me:",
    skills: "Skills:",
    experience: "Experience:",
    projects: "Projects:",
    contactMe: "Contact Me:",
    frontend: "Front-End:",
    backend: "Back-End:",
    misc: "Misc:",
    crm: "CRM & Automation:",
  },
  AboutMeText:
    "I’m a Full‑Stack Developer building production web applications end‑to‑end with React, Node.js, and TypeScript. I focus on clean architecture, type safety, and pragmatic engineering that ships. I collaborate closely with design, product, and QA to turn ideas into reliable, maintainable software.",
  AlwaysDiscovering:
    "I turn project feedback into better abstractions, cleaner code, stronger automation, and faster delivery—without sacrificing maintainability. Each release carries lessons forward, steadily improving performance, reliability, and developer experience.",
  yearsOfExperience: `
  Over the last 3+ years, I've been involved in a variety of projects of different sizes. I've worked closely with other engineers, designers, QA, and project managers. Each project has been a chance to grow, share knowledge with colleagues, and get better at developing high-quality software as part of a team.`,
  ContactMe: "If you came all this way, you probably liked what you've seen.",
  ContactMeBold: "if so, tell me about it!",
  MessageSent: "Thank you for your response!",
  ErrorMessage: "Something went wrong...",
} as const;

export default Text;
